import { useQuery } from "react-query";
import requestTrainingService from "@services/request-training-service";
import { trainingRequestsQueryKeys } from "./queryKeys";

export const useAvailableEmployeesQuery = (id: number) => {
  return useQuery(trainingRequestsQueryKeys.availableEmployees(id), () =>
    requestTrainingService.getAvailableEmployeesToAdd(id)
  );
};
